/********************************************************************
 * ADOBE CONFIDENTIAL
 *
 * Copyright 2025 Adobe
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

const getSystemTheme = () => {
	const darkThemeMq =
		window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)');

	return darkThemeMq.matches ? 'darkest' : 'light';
};

const ThemeUtils = {
	getSystemTheme,
};

export {ThemeUtils};
